export default function masks(){
    if(document.querySelector("#cpf")){
        $(document).ready(function(){
            $('#cpf').mask('000.000.000-00');
        });
    }
    if(document.querySelector("#phone")){
        $(document).ready(function(){
            $('#phone').mask('(00) 00000-0000');
        });
    }
}